import React from "react";

const Blockquote = ({ children }) => (
  <div className="ph3 f6 ba br2 hairline-1 bg-content--secondary mv3">
    {children}
  </div>
);

export default Blockquote;
